var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"show-icons"},_vm._l((_vm.iconObj),function(icon){return _c('div',{staticClass:"show-icons--container"},[_c('div',{staticClass:"show-icons--icon-container"},[_c(icon,{tag:"div",staticClass:"show-icons--icon-item"})],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(icon.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00267df9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primitives/icons/ShowIcons.vue
// module id = null
// module chunks = 